import { useAppAuthActions } from '../hooks/useAppAuth';
import { useTheme } from '../contexts/ThemeContext';
import AuthService from '../services/auth.service';
import logoLargeBlack from '../assets/images/pliable/logo_with_text_black.png';
import logoLargeWhite from '../assets/images/pliable/logo_with_text_white.png';

export default function NoDataAccess() {
  const { logout } = useAppAuthActions();
  const { theme } = useTheme();

  const whitelabelLogo = AuthService.getInstance().noDataAccessLogoUrl;
  const logoToUse = whitelabelLogo || (theme === 'dark' ? logoLargeWhite : logoLargeBlack);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-6 rounded-lg border p-8 shadow-sm">
        <div className="flex justify-center">
          <img src={logoToUse} alt="Logo" className="h-8" />
        </div>

        <div className="text-center space-y-2">
          <h1 className="text-xl font-semibold">No Data Access</h1>
          <p className="text-sm text-muted-foreground">
            You currently have no access to any data in the system. Please reach out to your system administrator to enable data access.
          </p>
        </div>

        <div className="text-center">
          <button
            onClick={() => logout()}
            className="text-sm text-muted-foreground underline hover:text-foreground"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
